import { render, staticRenderFns } from "./keepCustomerDetail.vue?vue&type=template&id=d724a50a&scoped=true&"
import script from "./keepCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./keepCustomerDetail.vue?vue&type=script&lang=js&"
import style0 from "./keepCustomerDetail.vue?vue&type=style&index=0&id=d724a50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d724a50a",
  null
  
)

export default component.exports